import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
@Injectable()
export class RcInviewService {

  public scrollEmitter = new EventEmitter();

  constructor() {
    window.addEventListener('scroll', () => {
      this.scrollEmitter.emit();
    });
  }

}
